import { ChangeDetectionStrategy, Component, DestroyRef, inject } from '@angular/core';
import { API, CompanyDTO, PointDTO, SSPDTO } from '../../../services/api/api';
import { ErrorService } from '../../../services/error.service';
import { UtilService } from '../../../services/util.service';
import { ModalNavigationComponent } from '../../../services/gui/modal/modal-navigation-component';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { StringTransformationService } from '../../../services/transformation-helper/string-transformation.service';
import { RequestClass } from '../../../services/global/RequestClass';

@Component({
  selector: 'sb-page-ssps',
  templateUrl: './ssps.component.html',
  styleUrls: ['./ssps.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SSPSComponent extends RequestClass implements ModalNavigationComponent {
  public readonly util = inject(UtilService);
  private readonly api = inject(API);
  protected readonly stringTransformation = inject(StringTransformationService);
  private readonly errorHandler = inject(ErrorService);
  private readonly destroyRef = inject(DestroyRef);

  // global variables
  isInModalContext: boolean;
  pos: PointDTO = null;

  // table wrapper variables
  ssps: SSPDTO[] = [];

  refreshFromServer() {
    if (!this.pagination) {
      this.loading.set(false);
      return;
    }
    const sub = this.api
      .shared_SSP_retrieveAll({}, this.pagination)
      .pipe(
        take(1),
        takeUntilDestroyed(this.destroyRef),
        finalize(() => {
          this.loading.set(false);
        })
      )
      .subscribe({
        next: (ssps: SSPDTO[]) => {
          this.ssps = ssps;
        },
        error: error => {
          this.errorHandler.errorHandler(error);
        },
      });
    this.subs.push(sub);
  }

  getSelectedLocationCoords(company: CompanyDTO) {
    if (company?.address?.position?.coordinates) {
      this.pos.data.coordinates = company.address.position.coordinates;
    }
  }
}
